import React from 'react';
import Dealer from './Dealer.js';

const DealerList = (props) => {
  return (
    props.dealers.length > 0 && (
      <div className="panel results">
        <div>
          {props.dealers.map((dealer, index) => {
            return (
              <Dealer
                dealer={dealer}
                setSelectedDealer={props.setSelectedDealer}
                activeCategoryName={props.activeCategoryName}
                translations={props.translations}
                index={index}
                key={index}
              />
            );
          })}
        </div>
      </div>
    )
  );
};

export default DealerList;
